import React from 'react';
function template(icon) {
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: icon } });
}
var InlineSvg = function (props) {
    return template(props.icon);
};
InlineSvg.displayName = 'InlineSVG';
export default InlineSvg;
export function asInlineSVG(icon) {
    return function () { return template(icon); };
}
//# sourceMappingURL=InlineSvg.js.map